/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssistitoAllergiaCreateDTO
 */
export interface AssistitoAllergiaCreateDTO {
    /**
     * 
     * @type {string}
     * @memberof AssistitoAllergiaCreateDTO
     */
    nome?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoAllergiaCreateDTO
     */
    sintomi?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoAllergiaCreateDTO
     */
    terapia?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoAllergiaCreateDTO
     */
    note?: string;
}

/**
 * Check if a given object implements the AssistitoAllergiaCreateDTO interface.
 */
export function instanceOfAssistitoAllergiaCreateDTO(value: object): value is AssistitoAllergiaCreateDTO {
    return true;
}

export function AssistitoAllergiaCreateDTOFromJSON(json: any): AssistitoAllergiaCreateDTO {
    return AssistitoAllergiaCreateDTOFromJSONTyped(json, false);
}

export function AssistitoAllergiaCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssistitoAllergiaCreateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'nome': json['nome'] == null ? undefined : json['nome'],
        'sintomi': json['sintomi'] == null ? undefined : json['sintomi'],
        'terapia': json['terapia'] == null ? undefined : json['terapia'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function AssistitoAllergiaCreateDTOToJSON(value?: AssistitoAllergiaCreateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'nome': value['nome'],
        'sintomi': value['sintomi'],
        'terapia': value['terapia'],
        'note': value['note'],
    };
}

